import React from "react";

import API from "@beardeddevops/react.api";
import Framework from '@beardeddevops/react.framework';
import Types from "constants/Types";
import TransactionCollection from "components/TransactionCollection";
import TransactionType from "../../constants/TransactionTypes";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

export default class Pawns extends TransactionCollection {
	constructor(props) {
		let model = new API.BuildClass(Types.Transactions._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_PAWNS';
		this.model.set = TransactionType.Acquisition;
	}

	componentDidMount() {
		if (location.hash && location.hash.substr(1)) {
			this.setState({search: location.hash.substr(1)});
		}
	}


	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		let pawnsearch = localStorage.getItem('pawn_search');
		if(pawnsearch && this.state.search !== pawnsearch) {
			this.setState({search: pawnsearch});
			localStorage.removeItem('pawn_search');
		}


	}

	render() {
		const {loading} = this.state;
		return (
			<Card>
				<CardContent>
					{super.render('Pawns', 'acquisitions', "Seller")}

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}